import React from 'react';
import TopImage from '../img/bg_3.jpg';

const Regulations = () => {
  return (
    <>
        <div className="history-image-wrapper">
        <img src={TopImage} alt="История конкурса" className="history-top-image" />
      </div>
    <div className="regulations-container">
      <h1 className="regulations-title">ПОЛОЖЕНИЕ</h1>
      <h2 className="regulations-subtitle">о проведении Международного конкурса дизайнеров одежды «Эволюция стиля»</h2>

      <section className="regulations-section">
        <h3>1. Общие положения</h3>
        <p><strong>1.1.</strong> Международный конкурс дизайнеров одежды «Эволюция стиля» (далее — Конкурс) проводится с целью выявления, поддержки и продвижения талантливых дизайнеров и предпринимателей в области моды.</p>
        <p><strong>1.2.</strong> Организатором Конкурса является Союз дизайнеров России.</p>
        <p><strong>1.3.</strong> Конкурс проводится ежегодно и включает этапы подачи заявок, предварительного отбора, демонстрации коллекций финалистов, публичных показов и объявления победителей.</p>
      </section>

      <section className="regulations-section">
        <h3>2. Цели и задачи Конкурса</h3>
        <p><strong>2.1.</strong> Содействие развитию индустрии моды и дизайна.</p>
        <p><strong>2.2.</strong> Поддержка профессиональных дизайнеров и предпринимателей, а также открытие новых имен в модной сфере.</p>
        <p><strong>2.3.</strong> Популяризация инновационных подходов, традиций и устойчивых практик в дизайне одежды.</p>
        <p><strong>2.4.</strong> Создание платформы для обмена опытом, знаниями и вдохновения между профессионалами модной индустрии.</p>
      </section>

      <section className="regulations-section">
        <h3>3. Сроки проведения Конкурса</h3>
        <p><strong>3.1.</strong> Прием заявок осуществляется с 1 апреля до 1 мая текущего года.</p>
        <p><strong>3.2.</strong> Основной этап проведения Конкурса: с 10 по 20 мая текущего года.</p>
        <p><strong>3.3.</strong> Объявление результатов и церемония награждения состоятся 25 мая текущего года.</p>
      </section>

      <section className="regulations-section">
        <h3>4. Участники Конкурса</h3>
        <p><strong>4.1.</strong> К участию приглашаются профессиональные дизайнеры и предприниматели модной индустрии с опытом работы не менее двух лет.</p>
        <p><strong>4.2.</strong> Участники могут представлять как индивидуальные, так и коллективные проекты, а также проекты брендов.</p>
        <p><strong>4.3.</strong> Для участия необходимо заполнить заявку на официальном сайте и предоставить портфолио с описаниями коллекций и эскизами или фотографиями изделий.</p>
      </section>

      <section className="regulations-section">
        <h3>5. Этапы Конкурса</h3>
        <p><strong>5.1. Регистрация и подача заявки</strong></p>
        <p>Участники заполняют онлайн-форму на официальном сайте, предоставляют сведения о себе, опыте работы и прикладывают портфолио с ключевыми проектами.</p>
        <p><strong>5.2. Предварительный отбор и экспертиза работ</strong></p>
        <p>Профессиональное жюри оценивает портфолио участников по критериям креативности, технического мастерства, инновационного подхода и соответствия актуальным трендам.</p>
        <p><strong>5.3. Финальный этап – публичные показы и презентации</strong></p>
        <p>Финалисты приглашаются представить свои коллекции на публичных показах в Москве.</p>
        <p><strong>5.4. Объявление победителей и награждение</strong></p>
        <p>Победители определяются на основе комплексной оценки представленных коллекций.</p>
      </section>

      <section className="regulations-section">
        <h3>6. Номинации и критерии оценки</h3>
        <p>Конкурс включает следующие номинации, каждая из которых оценивается по установленным критериям:</p>
        <p><strong>6.1. Лучший дизайнер мужской одежды</strong></p>
        <p><strong>Описание:</strong></p>
        <p>Признание выдающегося дизайнера мужской одежды за инновационный подход, мастерство и актуальность коллекции для современного мужчины.</p>
        <p><strong>Критерии оценки и баллы:</strong></p>
        <ul>
            <li>Оригинальность и креативность решений — <b>25 баллов</b></li>
            <li>Качество кроя, пошива и используемых материалов — <b>25 баллов</b></li>
            <li>Способность коллекции соответствовать потребностям и образу жизни современного мужчины — <b>25 баллов</b></li>
            <li>Влияние коллекции на индустрию и новые тренды — <b>25 баллов</b></li>
        </ul>

        <p className='mt-20'><strong>6.2. Лучший дизайнер женской одежды</strong></p>
        <p><strong>Описание:</strong></p>
        <p>Выдающийся дизайнер женской одежды за инновационные, выразительные и гармоничные коллекции, сочетающие классику и современность.</p>
        <p><strong>Критерии оценки и баллы:</strong></p>
        <ul>
            <li>Эстетическая выразительность и уникальность коллекции — <b>30 баллов</b></li>
            <li>Техническое мастерство и качество исполнения изделий — <b>25 баллов</b></li>
            <li>Способность адаптировать дизайн под различные типажи и стили — <b>20 баллов</b></li>
            <li>Значимость и оригинальность предложенных модных решений — <b>25 баллов</b></li>
        </ul>

        <p className='mt-20'><strong>6.3. Лучший дизайнер детской одежды</strong></p>
        <p><strong>Описание:</strong></p>
        <p>Номинация для дизайнера, создающего комфортные, безопасные и стильные вещи для детей, сочетающие креативность и практичность.</p>
        <p><strong>Критерии оценки и баллы:</strong></p>
        <ul>
            <li>Удобство и безопасность изделий — <b>30 баллов</b></li>
            <li>Яркость, игривость и оригинальность дизайна — <b>25 баллов</b></li>
            <li>Качество материалов и технологий пошива, пригодных для детей — <b>25 баллов</b></li>
            <li>Соответствие современным тенденциям в детской моде — <b>20 баллов</b></li>
        </ul>

        <p className='mt-20'><strong>6.4. Лучший инновационный дизайнер</strong></p>
        <p><strong>Описание:</strong></p>
        <p>Признание дизайнера, привносящего новаторские идеи, нестандартные материалы и технологии, открывающие новые горизонты в моде.</p>
        <p><strong>Критерии оценки и баллы:</strong></p>
        <ul>
            <li>Внедрение новых технологий и материалов — <b>30 баллов</b></li>
            <li>Смелость и креативность в поиске инновационных решений — <b>25 баллов</b></li>
            <li>Влияние инноваций на эстетический и функциональный уровень коллекции — <b>25 баллов</b></li>
            <li>Потенциал предложенных решений изменить индустрию или создать новые тренды — <b>20 баллов</b></li>
        </ul>

        <p className='mt-20'><strong>6.5. Выдающийся предприниматель года</strong></p>
        <p><strong>Описание:</strong></p>
        <p>Номинация для предпринимателя или владельца модного бренда, проявившего исключительные лидерские качества и значимый вклад в развитие индустрии.</p>
        <p><strong>Критерии оценки и баллы:</strong></p>
        <ul>
            <li>Достижения и рост бизнеса за отчетный период — <b>30 баллов</b></li>
            <li>Вклад в развитие индустрии и поддержку молодых талантов — <b>25 баллов</b></li>
            <li>Инновационные подходы к ведению бизнеса и маркетингу — <b>25 баллов</b></li>
            <li>Социальная и экологическая ответственность бренда — <b>20 баллов</b></li>
        </ul>

        <p className='mt-20'><strong>6.6. Лучшая инновация в текстиле</strong></p>
        <p><strong>Описание:</strong></p>
        <p>Категория для разработчиков уникальных текстильных материалов, демонстрирующих технологический прорыв и улучшающих качество и функциональность одежды.</p>
        <p><strong>Критерии оценки и баллы:</strong></p>
        <ul>
            <li>Уникальность и технологичность нового текстиля — <b>30 баллов</b></li>
            <li>Практическое применение инноваций в коллекциях — <b>25 баллов</b></li>
            <li>Экологичность и устойчивость материалов — <b>25 баллов</b></li>
            <li>Влияние текстильных инноваций на процессы производства и конечный продукт — <b>20 баллов</b></li>
        </ul>

        <p className='mt-20'><strong>6.7. Лучшая коллекция вечерней моды</strong></p>
        <p><strong>Описание:</strong></p>
        <p>Признание дизайнеров за выдающиеся коллекции вечерней одежды, сочетающие элегантность, утонченность и высокое мастерство.</p>
        <p><strong>Критерии оценки и баллы:</strong></p>
        <ul>
            <li>Элегантность и изысканность дизайна — <b>30 баллов</b></li>
            <li>Качество тканей, отделки и исполнения — <b>25 баллов</b></li>
            <li>Способность коллекции подчеркнуть статус и уникальность владельца — <b>25 баллов</b></li>
            <li>Соответствие актуальным модным тенденциям и инновационность решений — <b>20 баллов</b></li>
        </ul>

        <p className='mt-20'><strong>6.8. Лучший дизайнер молодежной моды</strong></p>
        <p><strong>Описание:</strong></p>
        <p>Номинация для дизайнеров, создающих модные, актуальные и самобытные коллекции для молодежи, отражающие дух нового поколения.</p>
        <p><strong>Критерии оценки и баллы:</strong></p>
        <ul>
            <li>Актуальность и модность коллекции — <b>30 баллов</b></li>
            <li>Способность уловить и интерпретировать запросы молодежи — <b>25 баллов</b></li>
            <li>Креативность, энергичность и оригинальность решений — <b>25 баллов</b></li>
            <li>Коммерческий и культурный потенциал коллекций на рынке молодежной моды — <b>20 баллов</b></li>
        </ul>
        <p className='mt-20'><i>Каждый эксперт жюри присваивает баллы по указанным критериям, суммируя их для определения победителей в каждой номинации.</i></p>
      </section>

      <section className="regulations-section">
        <h3>7. Условия участия</h3>
        <p><strong>7.1.</strong> Для участия в Конкурсе необходимо:</p>
        <ul>
          <li>Заполнить заявку на официальном сайте конкурса.</li>
          <li>Предоставить портфолио с описанием коллекций и примерами работ.</li>
        </ul>
      </section>

      <section className="regulations-section">
        <h3>8. Награждение</h3>
        <p><strong>8.1.</strong> Победители в каждой номинации получают дипломы, ценные призы, гранты.</p>
        <p><strong>8.2.</strong> Организатор оставляет за собой право вручать специальные награды.</p>
      </section>

      <section className="regulations-section">
        <h3>9. Заключительные положения</h3>
        <p><strong>9.1.</strong> Участие в Конкурсе означает полное согласие с настоящим Положением.</p>
        <p><strong>9.2.</strong> Организатор оставляет за собой право вносить изменения в Положение с предварительным уведомлением участников.</p>
        <p><strong>9.3.</strong>  Все вопросы, не урегулированные настоящим Положением, регулируются действующим законодательством Российской Федерации и правилами организации Конкурса, опубликованными на официальном сайте.</p>
      </section>
    </div>
    </>
  );
};

export default Regulations;
